/**
 * Auth Configuration
 * Re-exports from authService for backward compatibility
 */
import SuperTokens from 'supertokens-auth-react';
import Session from 'supertokens-auth-react/recipe/session';
import { API_BASE_URL } from '../utils/apiBaseUrl';

import {
  UserType as AuthUserType,
  ALL_USER_TYPES as AuthAllUserTypes,
  USER_TYPE_LABELS as AuthUserTypeLabels,
  USER_TYPE_COLORS as AuthUserTypeColors,
  Permissions as AuthPermissions,
  type UserTypeValue,
  type PermissionValue,
} from '../services/authService';

// Re-export with explicit const assignments to ensure they're available
export const UserType = AuthUserType;
export const ALL_USER_TYPES = AuthAllUserTypes;
export const USER_TYPE_LABELS = AuthUserTypeLabels;
export const USER_TYPE_COLORS = AuthUserTypeColors;
export const Permissions = AuthPermissions;

// Export types
export type { UserTypeValue, PermissionValue };

// Initialize SuperTokens session once (this ensures Session.init is called for the wrapper)
let _supertokensInitialized = false;
export function initSuperTokens() {
  if (_supertokensInitialized) return;

  try {
    SuperTokens.init({
      appInfo: {
        appName: 'brai',
        apiDomain: API_BASE_URL,
        websiteDomain: typeof window !== 'undefined' ? window.location.origin : '',
      },
      recipeList: [Session.init()],
    });

    _supertokensInitialized = true;
  } catch (err) {
    // Fail gracefully if SuperTokens cannot be initialized (e.g., during SSR or if library not intended to be used)
  }
}

// Legacy exports for backward compatibility
export function getSessionClaims(): Promise<{ roles: string[]; permissions: string[] } | null> {
  // No longer needed with JWT - roles/permissions are in the user object
  return Promise.resolve(null);
}

export function hasRole(roles: string[], role: string): boolean {
  return roles.includes(role) || roles.includes('superadmin');
}

export function hasPermission(permissions: string[], permission: string): boolean {
  return permissions.includes(permission);
}

export function isSuperAdmin(roles: string[]): boolean {
  return roles.includes('superadmin');
}

// Legacy exports
export const UserRoleClaim = null;
export const PermissionClaim = null;
